import { getTimeZone, setWeekStart } from '@grafana/data';
import { SceneObjectUrlSyncConfig } from '../services/SceneObjectUrlSyncConfig.js';
import { SceneObjectBase } from './SceneObjectBase.js';
import { getClosest } from './sceneGraph/utils.js';
import { parseUrlParam } from '../utils/parseUrlParam.js';
import { evaluateTimeRange } from '../utils/evaluateTimeRange.js';
import { config } from '@grafana/runtime';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class SceneTimeRange extends SceneObjectBase {
  constructor(state = {}) {
    var _a, _b;
    const from = (_a = state.from) != null ? _a : "now-6h";
    const to = (_b = state.to) != null ? _b : "now";
    const timeZone = state.timeZone;
    const value = evaluateTimeRange(
      from,
      to,
      timeZone || getTimeZone(),
      state.fiscalYearStartMonth,
      state.UNSAFE_nowDelay
    );
    super(__spreadValues({ from, to, timeZone, value }, state));
    this._urlSync = new SceneObjectUrlSyncConfig(this, { keys: ["from", "to", "timezone"] });
    this.onTimeRangeChange = (timeRange) => {
      const update = {};
      const updateToEval = {};
      if (typeof timeRange.raw.from === "string") {
        update.from = timeRange.raw.from;
        updateToEval.from = timeRange.raw.from;
      } else {
        update.from = timeRange.raw.from.toISOString();
        updateToEval.from = timeRange.raw.from.toISOString(true);
      }
      if (typeof timeRange.raw.to === "string") {
        update.to = timeRange.raw.to;
        updateToEval.to = timeRange.raw.to;
      } else {
        update.to = timeRange.raw.to.toISOString();
        updateToEval.to = timeRange.raw.to.toISOString(true);
      }
      update.value = evaluateTimeRange(
        updateToEval.from,
        updateToEval.to,
        this.getTimeZone(),
        this.state.fiscalYearStartMonth,
        this.state.UNSAFE_nowDelay
      );
      if (update.from !== this.state.from || update.to !== this.state.to) {
        this.setState(update);
      }
    };
    this.onTimeZoneChange = (timeZone) => {
      this.setState({ timeZone });
    };
    this.onRefresh = () => {
      this.setState({
        value: evaluateTimeRange(
          this.state.from,
          this.state.to,
          this.getTimeZone(),
          this.state.fiscalYearStartMonth,
          this.state.UNSAFE_nowDelay
        )
      });
    };
    this.addActivationHandler(this._onActivate.bind(this));
  }
  _onActivate() {
    if (!this.state.timeZone) {
      const timeZoneSource = this.getTimeZoneSource();
      if (timeZoneSource !== this) {
        this._subs.add(
          timeZoneSource.subscribeToState((n, p) => {
            if (n.timeZone !== void 0 && n.timeZone !== p.timeZone) {
              this.setState({
                value: evaluateTimeRange(
                  this.state.from,
                  this.state.to,
                  timeZoneSource.getTimeZone(),
                  this.state.fiscalYearStartMonth,
                  this.state.UNSAFE_nowDelay
                )
              });
            }
          })
        );
      }
    }
    if (this.state.weekStart) {
      setWeekStart(this.state.weekStart);
    }
    return () => {
      if (this.state.weekStart) {
        setWeekStart(config.bootData.user.weekStart);
      }
    };
  }
  getTimeZoneSource() {
    if (!this.parent || !this.parent.parent) {
      return this;
    }
    const source = getClosest(this.parent.parent, (o) => {
      if (o.state.$timeRange && o.state.$timeRange.state.timeZone) {
        return o.state.$timeRange;
      }
      return void 0;
    });
    if (!source) {
      return this;
    }
    return source;
  }
  getTimeZone() {
    if (this.state.timeZone) {
      return this.state.timeZone;
    }
    const timeZoneSource = this.getTimeZoneSource();
    if (timeZoneSource !== this) {
      return timeZoneSource.state.timeZone;
    }
    return getTimeZone();
  }
  getUrlState() {
    const urlValues = { from: this.state.from, to: this.state.to };
    if (this.state.timeZone) {
      urlValues.timezone = this.state.timeZone;
    }
    return urlValues;
  }
  updateFromUrl(values) {
    var _a, _b, _c;
    if (!values.to && !values.from) {
      return;
    }
    const update = {};
    const from = parseUrlParam(values.from);
    if (from) {
      update.from = from;
    }
    const to = parseUrlParam(values.to);
    if (to) {
      update.to = to;
    }
    if (typeof values.timezone === "string") {
      update.timeZone = values.timezone !== "" ? values.timezone : void 0;
    }
    update.value = evaluateTimeRange(
      (_a = update.from) != null ? _a : this.state.from,
      (_b = update.to) != null ? _b : this.state.to,
      (_c = update.timeZone) != null ? _c : this.getTimeZone(),
      this.state.fiscalYearStartMonth,
      this.state.UNSAFE_nowDelay
    );
    this.setState(update);
  }
}

export { SceneTimeRange };
//# sourceMappingURL=SceneTimeRange.js.map
